const alert = require('base/components/errorNotification');
var videoUtils = require('../util/videos');

/**
 * Init globally reusable modals for content links
 *
 * The function adds an event listener on the ".modal-link" class in a button element.
 *
 * Required Attributes:
 * data-link=”contentAssetURL” - This will be the Page Link to the Content Asset or Partial Page.
 *
 */

/**
 * Gets the modal content
 * @param {string} url - the get url
 * @param {string} pageSelector - the partial page container to use in the response html
 * @returns {Promise} - a promise resolved with the modal content
 */
function getModalContent(url, pageSelector) {
    var selectorString = pageSelector || '.content-asset-container';
    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            success: (html) => {
                var $content = $(html).find(selectorString);
                if ($content.length === 0) {
                    $content = $(html).clone();
                }

                $content.removeClass('container');
                resolve($content.html());
            },
            error: (err) => reject(err)
        });
    });
}

/**
 * Creates the modal jQuery element
 * @param {string} title - the modal's title content
 * @param {string} body - the modal's body content
 * @param {Object} options - display options
 * @returns {jQuery} - a modal
 */
function createModalElement(title, body, options) {
    var closeText = $('.modal-background').data('close');
    var html =
    `
    <div class="modal fade ${options.modalClass || ''}" tabindex="-1" role="dialog">
        <div class="modal-dialog ${options.modalSize} modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class=${(!title || !options.displayTitle) ? 'd-none' : ''}><h3 class="modal-title">${title}</h3></div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="${closeText}">
                        <span aria-hidden="true" class="content-modal-close"></span>
                    </button>
                </div>
                <div class="modal-body">${body || ''}</div>
                <div class="modal-footer ${(!options.displayFooter) ? 'd-none' : ''}">
                    <button class="btn btn-primary close-btn" data-dismiss="modal">${closeText}</button>
                </div>
            </div>
        </div>
    </div>
    `;

    return $(html);
}

module.exports = function () {
    $('body').on('click', '.modal-link', (e) => {
        e.preventDefault();
        var $link = $(e.currentTarget);
        var getUrl = $link.data('link');
        var title = $link.data('title') || '';
        var displayTitle = ($link.data('display-title') !== undefined) ? $link.data('display-title') : true;
        var displayFooter = ($link.data('display-footer') !== undefined) ? $link.data('display-footer') : true;
        var pageSelector = ($link.data('cid') !== undefined) ? '.' + $link.data('cid') : null;
        var modalSize = ($link.data('size') !== undefined) ? $link.data('size') : 'modal-lg';

        $.spinner().start();
        getModalContent(getUrl, pageSelector)
            .then((content) => {
                var displayOptions = {
                    displayTitle,
                    displayFooter,
                    modalSize
                };
                var $modal = createModalElement(title, content, displayOptions);
                $('body').append($modal);
                $modal.on('show.bs.modal', function () { $modal.focus(); });
                $modal.on('shown.bs.modal', function () {
                    $('.modal-header').trigger('focus');
                });
                $modal.on('hidden.bs.modal', function () {
                    $link.trigger('focus');
                    $modal.remove();
                });
                $modal.modal('show');
            }).catch(function (err) {
                window.console.error(err);
                alert($('.error-messaging'), $('.error-messaging').data('default-message'));
            })
            .finally(function () {
                $.spinner().stop();
            });
    });

    // global modal events
    $('.modal').on('show.bs.modal', function () {
        $(this).focus();
    }).on('shown.bs.modal', function () {
        $(this).find('.modal-header').trigger('focus');
    }).on('hidden.bs.modal', function (e) {
        $(e.currentTarget).trigger('focus');
    });

    $('body').on('click', '.video-modal-link, .text-video-link ', (e) => {
        e.preventDefault();
        var $link = $(e.currentTarget);
        $.spinner().start();
        var $modal = $('#' + $link.data('target'));
        $modal.addClass('pd-close');
        // append modal to the body so it works from absolutely positioned component regions
        // unbind and re-add namespaced click event in case of multiple watches
        $modal.appendTo('body').modal('show');
        $modal.off('shown.bs.modal.videos').on('shown.bs.modal.videos', function () {
            $('.modal-header').trigger('focus');
            // if triggered from inline poster image, just play the modal
            if ($link.hasClass('playNow')) {
                videoUtils.playPauseVideo($modal, 'play');
            } else if ($modal.find('.poster-img').length > 0) {
                videoUtils.initPosterImgEvents($modal);
            }
        });
        $modal.off('hide.bs.modal.videos').on('hide.bs.modal.videos', function () {
            videoUtils.playPauseVideo($modal, 'pause');
            videoUtils.resetPosterImage($modal);
        });
        $.spinner().stop();
    });
};
